<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("legal.menu.company") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormInput
                    :title="$t('legal.company.company_name')"
                    :placeholder="$t('legal.company.company_name_placeholder')"
                    v-model="footer.companyData.companyName"
                    required
                />
                <FormInputPreText
                    :title="$t('legal.company.internet_address')"
                    :placeholder="'google.com'"
                    v-model="legal.www"
                    prefix="https://"
                    required
                />
                <FormInput
                    :title="$t('legal.company.tax_id')"
                    placeholder="9512495989"
                    v-model="footer.companyData.taxId"
                />
                <template v-if="lang === 'pl'">
                    <FormInput
                        title="KRS"
                        placeholder="0000821672"
                        v-model="footer.companyData.krs"
                    />
                    <FormInput
                        title="REGON"
                        placeholder="385228325"
                        v-model="footer.companyData.regon"
                    />
                </template>

                <FormInputPreIcon
                    id="footerEmail"
                    :title="$t('shared.email')"
                    :placeholder="$t('shared.email_placeholder')"
                    icon="MailIcon"
                    v-model="footer.email"
                />
                <FormInputPreIcon
                    :title="$t('legal.company.email_for_complaints')"
                    :placeholder="$t('shared.email_placeholder')"
                    v-model="legal.email"
                    icon="MailIcon"
                />
                <FormInput
                    id="footerTel"
                    :title="$t('shared.phone_number')"
                    :placeholder="'+48 XXX XXX XXX'"
                    v-model="footer.tel"
                />
                <FormInput
                    id="footerAddress"
                    :title="$t('legal.company.street_address')"
                    :placeholder="$t('legal.company.street_address_placeholder')"
                    v-model="footer.companyData.streetAddress"
                />
                <div class="grid grid-cols-2 gap-6">
                    <FormInput
                        :title="$t('legal.company.building_number')"
                        v-model="footer.companyData.streetNumber"
                    />
                    <FormInput
                        :title="$t('legal.company.flat_number')"
                        v-model="footer.companyData.houseNumber"
                    />
                </div>
                <FormInput
                    :title="$t('legal.company.city')"
                    :placeholder="$t('legal.company.city_placeholder')"
                    v-model="footer.companyData.city"
                />
                <FormInput
                    :title="$t('legal.company.postal_code')"
                    :placeholder="$t('legal.company.postal_code_placeholder')"
                    v-model="footer.companyData.postalCode"
                />
                <FormInput
                    :title="$t('legal.company.country')"
                    :placeholder="$t('legal.company.country_placeholder')"
                    v-model="footer.companyData.country"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormInput, FormInputPreText, FormInputPreIcon } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        PageSidebar,
        FormInput,
        FormInputPreText,
        FormInputPreIcon,
        cSaveButton,
    },
    setup() {
        useFocusOnQueryField();
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("legal", ["footer", "legal", "hasChanges"]),
    },
    methods: {
        ...mapActions("legal/projects", ["saveSnapshot"]),
    },
};
</script>
